import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=51e5d4da&scoped=true&"
import script from "./InfoButton.vue?vue&type=script&lang=js&"
export * from "./InfoButton.vue?vue&type=script&lang=js&"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=51e5d4da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e5d4da",
  null
  
)

export default component.exports